import { render, staticRenderFns } from "./ReasonDialog.vue?vue&type=template&id=9dea9c60&scoped=true&"
import script from "./ReasonDialog.vue?vue&type=script&lang=js&"
export * from "./ReasonDialog.vue?vue&type=script&lang=js&"
import style0 from "./ReasonDialog.vue?vue&type=style&index=0&id=9dea9c60&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dea9c60",
  null
  
)

export default component.exports